import { useRouter } from 'next/router'
import { useEffect } from 'react'
import Analytics from 'react-ga4'
import { Seo } from 'ui-components'
import { TagManager } from 'utils'
import App, { getServerSideProps } from 'workspace'

function Workspace(props) {
  const router = useRouter()
  const { workspaceId, workspaceName } = router.query

  useEffect(() => {
    // Save page view whenever a user view this page.
    if (workspaceId)
      Analytics.send({
        hitType: 'pageview',
        page: `/${workspaceId}`
      })
  }, [workspaceId])

  TagManager.once(TagManager.dataLayer.viewWorkspace)

  return (
    <>
      <Seo
        title={workspaceName ? `${workspaceName} - workspace` : 'Loading...'}
      />
      <App
        {...props}
        workspaceId={workspaceId}
        workspaceName={workspaceName}
      />
    </>
  )
}

export { getServerSideProps }
export default Workspace
